module.exports = require('./lib').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 363
// module chunks = 95715928098905 128049163870319 241767136424496